/**
 * The current language that the user has the application set to. If the
 * language cannot be worked out that it defaults to "en-GB".
 * @type {String}
 */
export const LANGUAGE = document.documentElement.lang || "en-GB";
